const buildCarFormData = (values, imageFile, userId) => {

    const formData = new FormData();

    // رشته‌ها
    formData.append("title", values.title || "");
    formData.append("company", values.company || "");
    formData.append("shasiNo", values.shasiNo || "");

    // اعداد
    formData.append("pelak1", Number(values.pelak1) || 0);
    formData.append("pelak2", Number(values.pelak2) || 0);
    formData.append("pelak3", Number(values.pelak3) || 0);
    formData.append("pelak4", Number(values.pelak4) || 0);

    formData.append("productYear", Number(values.productYear) || 0);
    formData.append("kilometer", Number(values.kilometer) || 0);
    formData.append("useFuel", Number(values.useFuel) || 0);
    formData.append("distancePerWeek", Number(values.distancePerWeek) || 0);

    // شناسه کاربر
    formData.append("userId", userId);

    // عکس
    if (imageFile) {
        formData.append("File", imageFile);
        formData.append("FileSize", imageFile.size);
    }

    // لاگ زدن برای توسعه
    // for (const pair of formData.entries()) {
    //     console.log(pair[0], pair[1]);    
    // }

    return formData;

};

export default buildCarFormData;

